<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false
    },
    alpha: {
      type: Number,
      default: 1
    },
    color: {
      type: String,
      default: 'white'
    },
    size: {
      type: String,
      default: 'm'
    },
    rotate: {
      type: Number,
      default: 0
    }
  },
  computed: {
    classes () {
      return {
        xsmall: this.size === 'xs',
        small: this.size === 's',
        middle: this.size === 'm',
        large: this.size === 'l',
        xlarge: this.size === 'xl',
        full: this.size === 'full',
        [this.color]: true,
        active: this.active
      }
    },
    activeRotation () {
      return 45
    },
    styles () {
      if (this.active) {
        return {
          transform: 'rotate(' + (this.rotate + this.activeRotation) + 'deg)',
          'fill-opacity': this.alpha
        }
      } else {
        return {
          transform: 'rotate(' + this.rotate + 'deg)',
          'fill-opacity': this.alpha
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/uiColors';
@import '_baseIcon';
</style>
